import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { BhAlertService } from "bh-theme";
import { CONSTANTMESSAGE } from "./../../shared/constants/constants-messages";

/** Pass untouched request through to the next request handler. */
@Injectable({
  providedIn: "root",
})
export class ApiInterceptor implements HttpInterceptor {
  constructor(private _bhAlertService: BhAlertService) { }

  handleError(error: HttpErrorResponse) {
    this._bhAlertService.showAlert(
      'error', 'top',  3000, 
      error?.error ? error.error.Message : CONSTANTMESSAGE.FAILED_TO_LOAD_API
    );

    console.log("intercepor error", error)
    return throwError(() => error);
  }



  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: any) => {
        return this.handleError(err);
      })
    );
  }
}
